module.exports = __webpack_public_path__ + "static/media/Flag_of_the_United_Nations.ef7d993b.svg";